const MCP_USER_FACING_ASSET_TYPES = new Set([
  'TOOL',
  'MCP_TOOL',
  'MCP_PROMPT',
  'MCP_RESOURCE',
]);

export function isMcpUserFacingAssetType(type: string): boolean {
  return MCP_USER_FACING_ASSET_TYPES.has(type);
}
